import cn from 'classnames';
import { baseCellClassname } from '@lp/features/Scheduler/constants';
import { ResourceShiftTotalsMap } from '@lp/features/Scheduler/types';
import { BaseResource } from '@/api/apis/resources/schedule';

export type ResourceShiftTotalsTableProps<R extends BaseResource, T extends string> = {
  userRows: R[];
  shiftTotalsMap?: ResourceShiftTotalsMap<T>;
  shiftTotalsTypeList: T[];
  shiftTotalsTypeNames: Record<T, string>;
};

export const ResourceShiftTotalsTable = <R extends BaseResource, T extends string>({
  userRows,
  shiftTotalsMap,
  shiftTotalsTypeList,
  shiftTotalsTypeNames,
}: ResourceShiftTotalsTableProps<R, T>) => {
  return (
    <div className="absolute top-0 left-[220px] pr-6 overflow-hidden z-11">
      <table
        aria-label="Shift totals table"
        className="relative border-separate border-spacing-0 bg-white overflow-hidden rounded-r-2xl shadow-[0_0_16px_0_rgba(0,0,0,0.15)]"
      >
        <thead>
          <tr className="h-10 text-right bg-base-70">
            {shiftTotalsTypeList.map((shiftOption) => (
              <th key={shiftOption} className="bg-base-70 text-xs-sb text-base-20 px-2 min-w-[70px] last:pr-4">
                <span>{shiftTotalsTypeNames[shiftOption]}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {userRows.map((user) => (
            <tr key={user.id} className="h-[57px] text-right">
              {shiftTotalsTypeList.map((shiftOption) => (
                <td key={shiftOption} className={cn(baseCellClassname, 'px-2 last:pr-4 text-s-m text-base-20')}>
                  {shiftTotalsMap?.[user.id]?.[shiftOption] ?? 0}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
